export default "__VITE_ASSET__f2f492ac__"